(ns teamoesterreich.admin-mode.lebensretter.detail.log-part

  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.admin-mode.data.logs :as d-logs]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            ))




(defn log-block [selected-user]
  (let [!st (r/atom {:logs nil :loaded false :tomId 0})
        !tomId (r/cursor !st [:tomId])
        !logs (r/cursor !st [:logs])
        !loaded (r/cursor !st [:loaded])]
    (fn []
      (let [tomId (:user-tomId selected-user)
            user-uuid (:user-uuid selected-user)]
        (log/debug "Logs " (not (true? @!loaded)) (not= @!tomId tomId) (clj->js @!logs))
        (if (or (not (true? @!loaded)) (not= @!tomId tomId))
          ;not loaded
          (do
            (d-logs/<get-lrClearance-log-list tomId
                                              (fn [data] (swap! !st assoc
                                                                :logs data
                                                                :loaded true
                                                                :tomId tomId)))
            [mui/card {:style {:textAlign "left" :marginTop "10px"}}
             [mui/card-header
              {:title (str "Loading Logs.. " tomId)}]
             ])

          ;is loaded
          [mui/card {:style {:textAlign "left" :marginTop "10px"}}
           [ws-event-sync-component/ws-event-reload !loaded :user user-uuid]

           [mui/card-header
            {:title   (str "Freischaltung Verlauf")
             :onClick (fn []
                        (log/debug "reload")
                        (reset! !loaded false))}]

           [mui/card-content
            [mui/table
             [mui/table-head
              [mui/table-row
               [mui/table-cell "Datum"]
               [mui/table-cell "Admin"]
               [mui/table-cell "Beschreibung"]
               ]]

             [mui/table-body
              (for [[uuid entry] (filter (fn [[k v]] (not= (str (:log-message v)) ""))
                                         (reverse (sort-by (fn [[_ e]] (:log-date e)) @!logs)))]
                ^{:key (str "log-" uuid)}
                [mui/table-row
                 [mui/table-cell (h-date/print-local (:log-date entry))]
                 [mui/table-cell (str (get-in entry [:log-admin :user-firstName]) " " (get-in entry [:log-admin :user-lastName]))]
                 [mui/table-cell (:log-message entry)]
                 ])
              ]
             ]
            ]
           ]
          )
        ))))